/**
 * SyncError — 구조화된 Supabase 에러 전파
 *
 * ISSUE_130: Supabase PostgREST 에러의 `code` (PostgreSQL 에러코드)를
 * 보존하는 커스텀 에러 클래스.
 *
 * 기존 `throw new Error(error.message)`는 `code` 정보를 소실시켜
 * isPermanentError()에서 문자열 매칭만 가능했음.
 *
 * @module core/sync/SyncError
 */

export class SyncError extends Error {
  readonly code: string;

  constructor(message: string, code: string) {
    super(message);
    this.name = "SyncError";
    this.code = code;
  }

  /**
   * Supabase error 객체에서 SyncError 생성.
   * code가 없으면 "UNKNOWN"으로 대체.
   */
  static fromSupabase(error: { message: string; code?: string }): SyncError {
    return new SyncError(error.message, error.code ?? "UNKNOWN");
  }
}
